import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { AuthSelectors } from '@shared/store/auth/auth.selectors';

export const hasToFillPersonalDataGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);
  const router = inject(Router);


  return store.select(AuthSelectors.getCurrentLogged).pipe(
    map((accountData) => {
        if (accountData?.hasToCompletePersonalData) {
          return router.parseUrl('/auth/account-details');
        }
        return true;
      }
    ));
};